require('swiper');

(function(){
  var swiper;

  function initSwiper() {
    swiper = new Swiper('.swiper-container', {
    
      direction: 'horizontal',
      loop: false,
      slidesPerView: 3,
      pagination: '.swiper-pagination',
      resizeReInit: true,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      breakpoints: {
        1680: {
          slidesPerView: 2
        },
        1280: {
          slidesPerView: 1
        }
      }
    });
  }
  
  initSwiper();

})();

